import api from '../index';

export default {
  get(q = '', month = null, status = '') {
    let url = '/blog/faqs';
    const filters = [];

    q.trim() !== '' && filters.push(`q=${q}`);
    month && filters.push(`month=${month}`);
    status.trim() !== '' && filters.push(`status=${status}`);

    url = `${url}?${filters.join('&')}`;

    return api.get(url);
  },
  getById(id) {
    return api.get(`/blog/faqs/${id}`);
  },
  create(payload) {
    return api.post(`/blog/faqs`, { blog_faqs: payload });
  },
  update(payload) {
    return api.put(`/blog/faqs`, { blog_faqs: [payload] });
  },
  updateOrder(payload) {
    return api.put(`/blog/faqs`, { blog_faqs: payload });
  },
  delete(id) {
    return api.delete(`/blog/faqs/${id}`);
  },
};
